module.exports = __webpack_public_path__ + "static/media/13.9fe36bcc.svg";